import * as yup from "yup";
export const schema = yup
  .object({
    email: yup.string().required("*Email is required"),
    password: yup.string().required("*Password is required"),
    name: yup.string().required("*Name is required"),
    confirmPassword: yup.string().required("*Password mismatched"),
    gender: yup.string().nullable().required("*Select one value"),
    companyCode: yup.string().required("*Company code is required"),
  })
  .required();
